export default {
    page_title: "Kevi | Add Client",
    title: "Add Client",
    labels: {
        external_id: "Integration ID",
        first_name: "First name",
        last_name: "Last name",
        whatsapp: "Phone",
        email: "Email",
        birthdate: "Birthdate",
        subscribe: "Send:",
    },
    placeholders: {
        whatsapp: "(##) #####-####",
        birthdate: "dd/mm/yyyy",
    },
    channels: {
        sms: "SMS",
        email: "Email",
        whatsapp: "WhatsApp",
    },
    errors: {
        invalid_phone: "Invalid phone",
        duplicate_phone: "A client with this phone already exists",
        invalid_email: "Invalid email",
        duplicate_email: "A client with this email already exists",
        invalid_birthdate: "Invalid date",
    },
    cancel: "Cancel",
    save: "Save",
};
